// uploads.js

import { uploads } from '../actions';

const initialState = {
  template_key: '',
  upload_url: '',
  upload_key: '',
  preview_url: '',
  preview_key: '',
  watermarked_url: '',
  template_width: '',
  template_height: '',
  templateMetaData: {},
  file_data: '',
  status: uploads.types.READY
};

const upload_reducers = (state = initialState, action) => {
  let newstate;
  switch (action.type) {
    case uploads.types.LOADING:
      newstate = {
        status: action.type,
        template_key: action.template_key
      };
      return { ...state, ...initialState, ...newstate };
    case uploads.types.FETCHED_TEMPLATE_METADATA:
      newstate = {
        status: uploads.types.READY,
        templateMetaData: action.templateMetaData
      };
      return { ...state, ...newstate };
    case uploads.types.FETCHING_TEMPLATE_METADATA:
    case uploads.types.FETCHING_TEMPLATE_METADATA_FAILED:
    case uploads.types.READING:
    case uploads.types.READ:
      newstate = {
        status: action.type
      };
      if (action.file_data) newstate.file_data = action.file_data;
      return { ...state, ...newstate };
    case uploads.types.CANCELUPLOAD:
      newstate = {
        file_data: '',
        status: uploads.types.READY
      };
      return { ...state, ...newstate };
    case uploads.types.SIGNING:
      return { ...state, status: action.type };
    case uploads.types.SIGNED:
      newstate = {
        status: action.type,
        upload_url: action.upload_url,
        upload_key: action.upload_key
      };
      return { ...state, ...newstate };

    case uploads.types.UPLOADING:
    case uploads.types.UPLOADED:
    case uploads.types.TRANSFORMING:
      return { ...state, status: action.type };

    case uploads.types.COMPLETE:
      newstate = {
        status: action.type,
        preview_url: action.preview_url,
        watermarked_url: action.watermarked_url,
        preview_key: action.preview_key,
        template_width: action.template_width,
        template_height: action.template_height
      };
      return { ...state, ...newstate };
    default:
      return state;
  }
};

export default upload_reducers;



// WEBPACK FOOTER //
// ./src/store/reducers/uploads.js